import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const CalendarBlockedIcon = ({
  width = 24,
  height = 24,
  stroke = '#52575C',
  strokeWidth = 2,
  fill = '#52575C',
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill={fill}
      fillRule="evenodd"
      d="M17 2c0-.552-.447-1-1-1-.552 0-1 .448-1 1v1.001H9V2c0-.552-.448-1-1-1-.553 0-1 .448-1 1v1.001H5c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3h-2V2zm3 7.001v-3c0-.552-.448-1-1-1h-2V6c0 .552-.447 1-1 1-.552 0-1-.448-1-1v-.999H9V6c0 .552-.448 1-1 1-.553 0-1-.448-1-1v-.999H5c-.552 0-1 .448-1 1v3h16zm-16 2h16v9c0 .553-.448 1-1 1H5c-.552 0-1-.447-1-1v-9z"
      clipRule="evenodd"
    />
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeWidth={strokeWidth}
      d="M11.994 18.742c1.519 0 2.75-1.231 2.75-2.75s-1.231-2.75-2.75-2.75-2.75 1.231-2.75 2.75 1.231 2.75 2.75 2.75zM10.05 14.047l3.89 3.888"
    />
  </svg>
);
